// src/components/SearchSummaryBanner.jsx
// FIXED: Added safeText to prevent React Error #31

import React from 'react';
import './SearchSummaryBanner.css';

// Safe text helper - prevents React Error #31
const safeText = (value, fallback = '') => {
  if (value === null || value === undefined) return fallback;
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  if (typeof value === 'object') {
    if (value.city) return String(value.city);
    if (value.name) return String(value.name);
    if (value.code) return String(value.code);
    if (value.text) return String(value.text);
    return fallback;
  }
  return String(value);
};

const SearchSummaryBanner = ({ flightInfo }) => {
  // Safety check - if flightInfo is missing or invalid, return null
  if (!flightInfo || typeof flightInfo !== 'object') {
    return null;
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return safeText(dateStr);
  };

  const getAirportCode = (city) => {
    // Simple mapping - will be replaced with real data from Amadeus
    const codes = {
      'new york': 'JFK',
      'london': 'LHR',
      'los angeles': 'LAX',
      'chicago': 'ORD',
      'miami': 'MIA',
      'san francisco': 'SFO',
      'paris': 'CDG',
      'tokyo': 'NRT',
      'dubai': 'DXB'
    };
    const cityStr = safeText(city);
    return codes[cityStr.toLowerCase()] || cityStr;
  };

  // Safe property access
  const fromCode = getAirportCode(flightInfo.from);
  const toCode = getAirportCode(flightInfo.to);
  
  // Safe class handling
  const flightClass = safeText(flightInfo.class, 'economy');
  const classLabel = flightClass.charAt(0).toUpperCase() + flightClass.slice(1);
  
  // Safe passengers
  const passengers = Number(flightInfo.passengers) || 1;
  
  // Safe trip type
  const tripType = safeText(flightInfo.tripType, 'oneway');

  return (
    <div className="search-summary-banner">
      <span className="summary-text">
        <strong>Your current selection:</strong> {fromCode} to {toCode}
        {flightInfo.departDate && ` Departure: ${formatDate(flightInfo.departDate)}`}
        {flightInfo.returnDate && tripType === 'roundtrip' && ` Return: ${formatDate(flightInfo.returnDate)}`}
        {` ${classLabel} Class`}
        {` ${passengers} Passenger${passengers > 1 ? 's' : ''}`}.
      </span>
    </div>
  );
};

export default SearchSummaryBanner;
